/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreatePathwayDto } from '../../models/create-pathway-dto';
import { ResponsePathwayDto } from '../../models/response-pathway-dto';

export interface PathwaysControllerCreate$Params {
  
    /**
     * The pathway data to create
     */
    body: CreatePathwayDto
}

export function pathwaysControllerCreate(http: HttpClient, rootUrl: string, params: PathwaysControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<ResponsePathwayDto>> {
  const rb = new RequestBuilder(rootUrl, pathwaysControllerCreate.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ResponsePathwayDto>;
    })
  );
}

pathwaysControllerCreate.PATH = '/thalea-pathways/pathways';
